import { CampaignPositionStatus } from '@/services/ws-print-operations/src/main/resources/rest-api';

import type { ParamsValidator } from 'src/components/RouteParamsValidator';
import type { PrintOperationsRouteParams } from './types';

const POSITIONS_STATUSES = Object.values(CampaignPositionStatus);

export const validatePrintOperationStatus: ParamsValidator<PrintOperationsRouteParams> = ({ status }) =>
  [...POSITIONS_STATUSES].includes(status);
